"use client";

import React from "react";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import {
	Stack,
} from "@mui/material";

import { WizardSchemaType } from "../index";
import EventSessionPricingItem from "./event-session-pricing-item";

interface PropTypes {
	methods: UseFormReturn<WizardSchemaType>;
}

const EventSessionPricingEach: React.FC<PropTypes> = ({ methods }) => {
	const { control } = methods;

	const { fields } = useFieldArray({
		control,
		name: "stepTimeline.sessions",
	});

	return (
		<Stack spacing={2}>
			{fields.map((field, index) => {
				return (
					<EventSessionPricingItem
						key={field.id}
						index={index}
						methods={methods}
					/>
				);
			})}
		</Stack>
	);
};

export default EventSessionPricingEach;
